<div class="sample-form-container">
  <form #SampleForm="ngForm">
    <rms-select name="InventoryTypeID" [required]="true" label="Coffee" [options]="InventoryTypes" labelKey="InventoryTypeName" valueKey="InventoryTypeID" [(ngModel)]="Sample.InventoryTypeID"></rms-select>
    <rms-date name="FollowUpDate" label="Follow Up Date" [(ngModel)]="Sample.FollowUpDate"></rms-date>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!SampleForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
